import { Component, Input } from '@angular/core';
import { HouseFlat } from '../../models/house-flat.model';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HouseFlatService } from '../../services/house-flat.service';
import { UtilService } from '../../services/util.service';
import { ResidentTypeService } from '../../services/resident-type.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-house-flat-modal',
  templateUrl: './house-flat-modal.component.html',
  styleUrl: './house-flat-modal.component.scss'
})
export class HouseFlatModalComponent {

  @Input() houseFlat?: HouseFlat;
  @Input() neighborhoodId: string = '';
  @Input() streetBuildingId: string = '';

  public dataForm: DataFormModel = {
    number: {
      value: '',
      type: 'text',
      label: 'Número de casa',
      requiredMessage: 'Por favor, ingrese el nombre de la casa',
      required: true,
      validators: [Validators.required]
    },
    fullName: {
      value: '',
      type: 'text',
      label: 'Nombre completo del propietario',
      required: false,
      validators: []
    },
    residentTypeId: {
      value: null,
      type: 'select',
      idSelect: 'residentTypeId',
      labelSelect: 'description',
      data: [],
      label: 'Tipo de residente',
      placeholder: 'Seleccione el tipo de residente',
      required: false,
      validators: []
    },
    phone: {
      value: '',
      type: 'text',
      label: 'Número telefónico',
      required: false,
      validators: []
    },
    notes: {
      value: '',
      type: 'textarea',
      label: 'Notas',
      required: false,
      validators: []
    },
    status: {
      value: false,
      type: 'switch',
      label: '¿Esta al corriente?',
      required: false,
    },
    bookingModule: {
      value: true,
      type: 'switch',
      label: 'Módulo de reservación',
      required: false,
    },
    surveysModule: {
      value: true,
      type: 'switch',
      label: 'Módulo de encuestas',
      required: false,
    },
    chatModule: {
      value: true,
      type: 'switch',
      label: 'Módulo de chat',
      required: false,
    },
    digitalKeychainModule: {
      value: true,
      type: 'switch',
      label: 'Módulo de llavero digital',
      required: false,
    },
    packageModule: {
      value: true,
      type: 'switch',
      label: 'Módulo de paquetería',
      required: false,
    },
    reportsModule: {
      value: true,
      type: 'switch',
      label: 'Módulo de reportes',
      required: false,
    },
    canCreatePermanentPasses: {
      value: true,
      type: 'switch',
      label: 'Pases recurrentes',
      required: false,
    },
  };

  public submitted: boolean = false;
  public loading: boolean = false;

  public formHouseFlat!: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    public authService: AuthService,
    public houseFlatService: HouseFlatService,
    private residentTypeService: ResidentTypeService,
    public utilService: UtilService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formHouseFlat.controls;
  }


  /*
   ██████╗██████╗ ███████╗ █████╗ ████████╗███████╗
  ██╔════╝██╔══██╗██╔════╝██╔══██╗╚══██╔══╝██╔════╝
  ██║     ██████╔╝█████╗  ███████║   ██║   █████╗
  ██║     ██╔══██╗██╔══╝  ██╔══██║   ██║   ██╔══╝
  ╚██████╗██║  ██║███████╗██║  ██║   ██║   ███████╗
   ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
   async create() {

    const flag = await this.houseFlatService.create(
      this.neighborhoodId!,
      this.streetBuildingId!,
      this.formHouseFlat.value,
    );

    if(flag) {
      for(let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }

  }

  /*
  ██╗      ██████╗  █████╗ ██████╗ ██████╗  █████╗ ████████╗ █████╗
  ██║     ██╔═══██╗██╔══██╗██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗
  ██║     ██║   ██║███████║██║  ██║██║  ██║███████║   ██║   ███████║
  ██║     ██║   ██║██╔══██║██║  ██║██║  ██║██╔══██║   ██║   ██╔══██║
  ███████╗╚██████╔╝██║  ██║██████╔╝██████╔╝██║  ██║   ██║   ██║  ██║
  ╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝ ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝

  */
  async loadData() {
    this.loading = true;

    this.dataForm['residentTypeId'].data = await this.residentTypeService.getAll();

    if(this.houseFlat) {

      this.dataForm = {
        ...this.dataForm,
      }

      for(let key of Object.keys(this.dataForm)) {

        if (key in this.houseFlat!) {
          const standardKey = key as keyof typeof this.houseFlat;
      
          // Ahora puedes acceder a `this.machine[machineKey]` sin errores de tipo.
          this.dataForm[key].value = this.houseFlat[standardKey]!;
        }
      } 
    }
    
    this.formHouseFlat = this.utilService.buildForm(this.dataForm);

    this.loading = false;
  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗   ██╗██████╗ ███╗   ███╗██╗████████╗
  ██╔═══██╗████╗  ██║██╔════╝██║   ██║██╔══██╗████╗ ████║██║╚══██╔══╝
  ██║   ██║██╔██╗ ██║███████╗██║   ██║██████╔╝██╔████╔██║██║   ██║
  ██║   ██║██║╚██╗██║╚════██║██║   ██║██╔══██╗██║╚██╔╝██║██║   ██║
  ╚██████╔╝██║ ╚████║███████║╚██████╔╝██████╔╝██║ ╚═╝ ██║██║   ██║
   ╚═════╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝   ╚═╝

  */
  async onSubmit() {

    console.log(this.formHouseFlat.value);
    
    this.submitted = true;

    if(this.formHouseFlat.invalid) {
      return;
    }

    if(this.houseFlat) {

      await this.update();
    } else {
      await this.create();
    }
  }

  /*
  ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗
  ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝
  ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗
  ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝
  ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗
   ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async update() {

    this.formHouseFlat.value.streetBuildingId = this.houseFlat!.streetBuildingId;
    this.formHouseFlat.value.houseFlatId = this.houseFlat!.houseFlatId;

    const flag = await this.houseFlatService.update(
      this.neighborhoodId!,
      this.formHouseFlat.value
    );

    if(flag) {

      for(let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }
  }

}
